// Marquee.jsx
import { Box, Typography } from '@mui/material';
import background from '../assets/services-bg.webp';

const items = [
  'Bussiness', 'Manufacturing',
  'Build', 'Connect', 'Grow', 'Inspire', 'Build',
  'Connect', 'Grow', 'Inspire'
];

const LogoCollection = () => {
  return (
    <Box
      sx={{
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        backgroundImage: `url(${background})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        py: 6,
      }}
    >
      <Box
        sx={{
          display: 'inline-flex',
          animation: 'scroll 40s linear infinite',
          gap: '20px',
        }}
      >
        {[...items, ...items].map((text, index) => (

        <Typography
          key={index}
          component="h4"
          sx={{
            pointerEvents: 'none',
            userSelect: 'none',

            color: 'rgb(255, 255, 255)',
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            borderRadius: '8px',

            fontFamily: 'Rajdhani, sans-serif',
            fontWeight: 600,
            fontSize: '30px',
            lineHeight: '36px',

            height: '56px',
            width: 'fit-content',

            paddingTop: '10px',
            paddingBottom: '10px',
            paddingLeft: '35px',
            paddingRight: '35px',

            marginTop: '11px',
            marginBottom: '0px',

            display: 'block',
            position: 'relative',
            textAlign: 'center',

            boxSizing: 'border-box',
            transition: 'all 0.5s ease',

            WebkitFontSmoothing: 'antialiased',
            WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
          }}
        >
          {text}
        </Typography>

        ))}
      </Box>

      <style>
        {`
          @keyframes scroll {
            0% { transform: translateX(0%); }
            100% { transform: translateX(-50%); }
          }
        `}
      </style>
    </Box>
  );
};

export default LogoCollection;
